
const componentsStructure = [
    {
        id: 'home',
        label: 'Home',
        managerAlwaysOn: true,
        userAlwaysOn: true,
        guestAlwaysOn: true,
        clientAlwaysOff: true,
        // clientAlwaysOn: true,
    },
    {
        id:    'projects',
        label: 'Projects',
        clientAlwaysOn: true,
    },
    {
        id: 'tools',
        label: 'Tools',
        clientAlwaysOff: true,
    },
    {
        id: 'goals',
        label: 'Goals',
        clientAlwaysOff: true,
    },
    {
        id: 'chat',
        label: 'Chats',
        clientAlwaysOn: true,
    },
    {
        id: 'quick-add',
        label: 'Quick add',
        clientAlwaysOff: true,
    },
    {
        id: 'search',
        label: 'Search',
        clientAlwaysOff: true,
    },
    {
        id: 'users',
        label: 'Users',
        clientAlwaysOff: true,
    },
    {
        id: 'settings',
        label: 'Settings',
        managerAlwaysOn: true,
        userAlwaysOn: true,
        guestAlwaysOn: true,
        clientAlwaysOff: true,
    },
    {
        id: 'help',
        label: 'Help & Support',
        clientAlwaysOff: true,
    },
    {
        id: 'my-account',
        label: 'My account',
        managerAlwaysOn: true,
        userAlwaysOn: true,
        guestAlwaysOn: true,
        clientAlwaysOn: true,
    },

];


export default class PermissionsComponents {

    public structure                : any
    public currentUserPermissions   : any
    public permissions              : any

    constructor() {

        if (!gd.companyId) {
            console.warn("#mckd099 PermissionsComponents no company set")
            return
        }

        this.structure = componentsStructure;
        this.initPermissions();

        switch (gd.session.companies.get(gd.companyId).role) {
            case gd.const.company.role.MANAGER  : this.currentUserPermissions = this.permissions.manager; break;
            case gd.const.company.role.USER     : this.currentUserPermissions = this.permissions.user; break;
            case gd.const.company.role.GUEST    : this.currentUserPermissions = this.permissions.guest; break;
            case gd.const.company.role.CLIENT   : this.currentUserPermissions = this.permissions.client; break;
            default:
                console.error("#99djkas Unknonw User company role");
        }

        // console.log("Cur user permissions", this.currentUserPermissions);
    }

    initPermissions() {
        const companySettings = gd.session.companies.get(gd.companyId).settings;

        const disabledComponentsManager = companySettings.permissions.disabledComponents.manager;
        const disabledComponentsUser = companySettings.permissions.disabledComponents.user;
        const disabledComponentsGuest = companySettings.permissions.disabledComponents.guest;
        const disabledComponentsClient = companySettings.permissions.disabledComponents.client;

        this.permissions = {
            manager : {},
            user    : {},
            guest   : {},
            client  : {}
        };

        this.structure.map((component:any)=>{
            this.permissions.manager[component.id]  = !disabledComponentsManager.has(component.id);
            this.permissions.user[component.id]     = !disabledComponentsUser.has(component.id);
            this.permissions.guest[component.id]    = !disabledComponentsGuest.has(component.id);
            this.permissions.client[component.id]   = !disabledComponentsClient.has(component.id);

            // component.items && component.items.map(subComponent=>{
            //     this.permissions.manager[subComponent.id] = !disabledComponentsManager.includes(subComponent.id);
            //     this.permissions.user[subComponent.id] = !disabledComponentsUser.includes(subComponent.id);
            //     this.permissions.guest[subComponent.id] = !disabledComponentsGuest.includes(subComponent.id);
            // })
        });
    }

    hasAccess(componentName:any) {

        switch (componentName) {

            case 'chat':
                if (!gd.modules.chats.enabled) return false
                return this.currentUserPermissions[componentName];

            case 'goals':
                if (!gd.modules.goals.enabled) return false

            default:
                return this.currentUserPermissions[componentName];
        }



    }

    getDefaultComponentId() {
        let res:any = null;

        _.some(this.structure, component=>{
            if (this.hasAccess(component.id)) res = component.id;
            return !!res;
        })

        return res;
    }
}
